import { render } from "./ModalOverlay.vue?vue&type=template&id=d58b7314&scoped=true&ts=true"
import script from "./ModalOverlay.vue?vue&type=script&lang=ts"
export * from "./ModalOverlay.vue?vue&type=script&lang=ts"

import "./ModalOverlay.vue?vue&type=style&index=0&id=d58b7314&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d58b7314"]])

export default __exports__